
import BillManagerContent from "../../components/RevenueFromService/BillManager/BillManagerContent";
import { APIDataLoader } from "../../util/APIDataLoader";

function BillManager() {
    return (
        <BillManagerContent />
    )
}

export default BillManager;

export async function loader() {
    const promises = await Promise.all([
        APIDataLoader('rateSelector'),
        APIDataLoader('billingSelector'),
        APIDataLoader('customerSelector')
    ]);

    return {
        rateFilterData: promises[0],
        billingCycleFilterData: promises[1],
        customerFilterData: promises[2]
    };
}
